// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { IconBoolean } from '@Atoms/Info/IconBoolean/IconBoolean';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

interface IsSightedProps {
    value?: boolean;
    onChange?: (newValue: boolean) => void;
    onClick?: () => void;
    readOnly?: boolean;
}

export const IsSighted = ({ value, onChange, onClick, readOnly = false }: IsSightedProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <IconBoolean
            icon={<ICONS.SightedIcon />}
            value={!!value}
            onClick={(): void => {
                onClick?.();
                onChange?.(!value);
            }}
            readOnly={readOnly}
            label={i('common.sighted')}
        />
    );
};
